import * as React from 'react';
import { ExperimentProvider } from '../experiment-context';
/**
 * A provider intended for development and unit testing render trees that have nodes of type `Experiment`, `ExperimentControl`, and `ExperimentVariant`.
 *
 * You simply pass your mockExperiments object as a prop and it will autowire `ExperimentProvider` to lookup those experiment bucket values and perform a no-op `logExperiment()`.
 *
 * @example
 * describe('<DetailsComponent />', () => {
 *    it('should render a title', () => {
 *      const wrapper = render(<DetailsComponent {someMockProps} />);
 *
 *      expect(wrapper.find('h3').text()).toBe('Stuff About this Place!');
 *    });
 *
 *    it('should not render a title in variant 1 of DETAILS_NO_TITLE experiment', () => {
 *      const mockExperiments = {...};
 *      const wrapper = render(
 *        <MockExperimentProvider experiments={mockExperiments}>
 *          <DetailsComponent {...someMockProps} />
 *        </MockExperimentProvider>
 *      );
 *
 *      expect(wrapper.find('h3')).toHaveLength(0);
 *    });
 * });
 */
export var MockExperimentProvider = function (props) {
    var experiments = props.mockExperiments || {};
    var experimentConfig = {
        getExposure: function (name) { return (experiments.hasOwnProperty(name) && experiments[name]) || null; },
        logExperiment: function (exposure) { return void (0); }
    };
    return (React.createElement(ExperimentProvider, { config: experimentConfig }, props.children || null));
};
//# sourceMappingURL=mock-experiment-provider.js.map